export default __webpack_public_path__ + "static/media/uploader-medtronic-2.97ef8156.png";